<template>
  <div class="product-manager">
    <a-card>
      <!-- 查询区 -->
      <a-form class="search-bar">
        
        <a-row :gutter="8">
          <a-col :span="6">
            <a-form-item label="产品名称" :labelCol="{ flex: '70px' }" :wrapperCol="{ flex: 'auto' }">
            <a-input placeholder="请输入产品名称" style="width: 100%" />            
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="产品ID" :labelCol="{ flex: '70px' }" :wrapperCol="{ flex: 'auto' }">
            <a-input placeholder="请输入产品ID" style="width: 100%" />
          </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="设备类型" :labelCol="{ flex: '70px' }" :wrapperCol="{ flex: 'auto' }">
            <a-select placeholder="请选择设备类型" style="width: 100%" allowClear />
          </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="标签" :labelCol="{ flex: '70px' }" :wrapperCol="{ flex: 'auto' }">
              <a-input placeholder="请选择标签" style="width: 100%" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="8" style="margin-top: 1px;">
          <a-col :span="6">
            <a-form-item label="网络" :labelCol="{ flex: '70px' }" :wrapperCol="{ flex: 'auto' }">
              <a-select placeholder="请选择网络" style="width: 100%" allowClear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="数据协议" :labelCol="{ flex: '70px' }" :wrapperCol="{ flex: 'auto' }">
              <a-select placeholder="请选择数据协议" style="width: 100%" allowClear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
              <a-form-item>
                <a-button type="primary">+ 新增</a-button>
              </a-form-item>
          </a-col>
          <a-col :span="6">
              <a-form-item>
                <a-button type="text" :class="{ active: viewMode === 'card' }" @click="viewMode = 'card'">
                  <font-awesome-icon icon="fa-solid fa-table-cells-large" />
                </a-button>
                <a-button type="text" :class="{ active: viewMode === 'list' }" @click="viewMode = 'list'">
                  <font-awesome-icon icon="fa-solid fa-list" />
                </a-button>
                <a-button type="primary" style="margin-right: 8px;">查询</a-button>
                <a-button style="margin-right: 8px;">重置</a-button>
              </a-form-item>
          </a-col>                  
        </a-row>
      </a-form>
      <!-- 卡片区 -->
      <div v-if="viewMode === 'card'" class="card-list">
        <a-card class="product-card">
          <div class="card-header">
            <span class="card-title">生成器</span>
            <a-button
              size="small"
              :class="{
                'status-btn': true,
                'status-enabled': cardStatus === 'enabled',
                'status-disabled': cardStatus === 'disabled',
                'status-disconnected': cardStatus === 'disconnected',
              }"
            >
              {{ cardStatusText }}
            </a-button>
          </div>
          <div class="card-body">
            <div class="card-info">
              <div>产品编号：001</div>
              <div>产品品类：传感器设备</div>
              <div>设备类型：设备</div>
              <div>通讯方式：其他</div>
              <div>创建时间：2025/5/2 20:03:18</div>
              <div>标签：<a-tag>无标签</a-tag></div>
            </div>
            <div class="card-img">
              <a-image :width="80" :height="80" :preview="false" src="https://img.icons8.com/ios/100/000000/image.png" />
            </div>
          </div>
          <div class="card-footer">
            <a-button type="default" size="small">详情</a-button>
            <a-button type="primary" size="small">管理设备</a-button>
            <a-button type="danger" size="small">删除</a-button>
          </div>
        </a-card>
      </div>
      <a-table v-else :columns="columns" :data-source="dataSource" :pagination="false">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'status'">
            <a-tag color="green">启用</a-tag>
          </template>
          <template v-else-if="column.key === 'action'">
            <a @click="() => {}" style="color:#1677ff; margin-right:8px;">详情</a>
            <a @click="() => {}" style="color:#1677ff; margin-right:8px;">管理设备</a>
            <a @click="() => {}" style="color:#ff4d4f;">删除</a>
          </template>
        </template>
      </a-table>
      <!-- 分页区 -->
      <div class="pagination-bar">
        <span>共1条</span>
        <a-pagination :total="1" :pageSize="12" :current="1" style="margin: 0 16px;" />
        <a-select :value="12" style="width: 90px;">
          <a-select-option :value="12">12条/页</a-select-option>
          <a-select-option :value="24">24条/页</a-select-option>
        </a-select>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const viewMode = ref('card')
const columns = [
  { title: '产品ID', dataIndex: 'id', key: 'id' },
  { title: '产品名称', dataIndex: 'name', key: 'name' },
  { title: '设备类型', dataIndex: 'type', key: 'type' },
  { title: '通讯方式', dataIndex: 'comm', key: 'comm' },
  { title: '数据协议', dataIndex: 'protocol', key: 'protocol' },
  { title: '品类', dataIndex: 'category', key: 'category' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  {
    id: '001',
    name: '生成器',
    type: '设备',
    comm: '其他',
    protocol: '联犀MQTT协议',
    category: '传感器设备',
    status: '启用',
    createdAt: '2025/5/2 20:03:18'
  }
]
const cardStatus = ref('enabled') // enabled, disabled, disconnected
const cardStatusText = computed(() => {
  if (cardStatus.value === 'enabled') return '启用'
  if (cardStatus.value === 'disabled') return '禁用'
  if (cardStatus.value === 'disconnected') return '断开'
  return ''
})
</script>

<style lang="less" scoped>
.product-manager {
  .search-bar {
    margin-bottom: 16px;
    flex-wrap: wrap;
    align-items: center;
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
    .product-card {
      width: 420px;
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        .card-title { font-weight: bold; font-size: 18px; }
      }
      .card-body {
        display: flex;
        justify-content: space-between;
        .card-info { font-size: 14px; line-height: 2; }
        .card-img { display: flex; align-items: center; }
      }
      .card-footer {
        margin-top: 12px;
        display: flex;
        gap: 8px;
      }
    }
  }
  .pagination-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
  }
}

.active {
  color: #1677ff;
  background: #e6f7ff;
}

.status-btn {
  color: #fff;
  border: none;
}
.status-enabled {
  background: #52c41a;
}
.status-disabled {
  background: #ff4d4f;
}
.status-disconnected {
  background: #bfbfbf;
}
</style> 